{
  "SEARCH": {
    "TABS": {
      "ALL": "Όλες",
      "CONTACTS": "Επαφές",
      "CONVERSATIONS": "Συζητήσεις",
      "MESSAGES": "Μηνύματα"
    },
    "SECTION": {
      "CONTACTS": "Επαφές",
      "CONVERSATIONS": "Συζητήσεις",
      "MESSAGES": "Μηνύματα"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Αναζήτηση",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ to focus",
    "INPUT_PLACEHOLDER": "Search messages, contacts or conversations",
    "RECENT_MESSAGES": "Τα πρόσφατα απεσταλμένα μηνύματά μου",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results.",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Read more",
    "WROTE": "wrote:",
    "FROM": "από",
    "EMAIL": "email",
    "EMAIL_SUBJECT": "θέμα"
  }
}
